/**
 * Browser marketing launch path.
 * Native shells, PWA start_url, and /play/connect keep /app-beta.
 */
export const MARKETING_APP_HREF = '/app'
export const MARKETING_SIGN_IN_HREF = `/signin?callbackUrl=${encodeURIComponent('/app')}`
